export default __webpack_public_path__ + "static/media/gallery_00.384090c9.jpg";